import { render, staticRenderFns } from "./numeric-field.vue?vue&type=template&id=9385fad4&scoped=true&lang=pug"
import script from "./numeric-field.vue?vue&type=script&lang=js"
export * from "./numeric-field.vue?vue&type=script&lang=js"
import style0 from "./numeric-field.vue?vue&type=style&index=0&id=9385fad4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9385fad4",
  null
  
)

export default component.exports